module.exports = __webpack_public_path__ + "media/images/mobile/solutions/mobile-bar-d964aed30e2124762af48bda94d73aa9.png";